import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { ColumnProps } from 'components/@common/Table/LwtTable';
import { TFunction } from 'i18next';
import ModuleStatusChip from 'components/ReportsModule/components/KeyboardingReport/AccessmentAcceleratorComponents/ModuleStatusChip';
import {
  appendSecondsOrFallback,
  getDefaultText
} from 'components/ReportsModule/components/KeyboardingReport/keyboarding-report-util';
import { ReportEntityType } from 'components/ReportsModule/types';
import ReportLink from 'components/ReportsModule/components/common/ReportLink';

const Title = ({ children }: any) => (
  <Typography style={{ fontSize: 12, fontWeight: 600 }}>{children}</Typography>
);

const ModuleStatusHelp: any = (
  <Box>
    <Typography variant="body1" style={{ padding: '1px 0px', fontSize: 14 }}>
      Not Assigned = Module not yet assigned
    </Typography>

    <Typography variant="body1" style={{ padding: '1px 0px', fontSize: 14 }}>
      Assigned = Module assigned to the student
    </Typography>

    <Typography variant="body1" style={{ padding: '1px 0px', fontSize: 14 }}>
      In-Progress = Student has started the module
    </Typography>

    <Typography variant="body1" style={{ padding: '1px 0px', fontSize: 14 }}>
      Completed = Student has completed the module
    </Typography>
  </Box>
);

const getAllStudentModuleColumns: (t: TFunction, tUpper: TFunction) => ColumnProps<any>[] = (
  t: TFunction,
  tUpper
) => {
  return [
    {
      id: 'studentName',
      label: <Title>{tUpper('Student')}</Title>,
      sortKey: 'studentName',
      getValue: item => {
        return (
          <ReportLink
            key={item?.studentId}
            entityType={ReportEntityType.STUDENT}
            entityId={item?.studentId}
          >
            {item.studentName}
          </ReportLink>
        );
      },

      sortable: true
    },
    {
      id: 'timePerQuestion',
      label: <Title>{tUpper('Avg Time Per Question')}</Title>,
      sortKey: 'timePerQuestion',
      getValue: item => <Typography>{appendSecondsOrFallback(item.timePerQuestion)}</Typography>,
      sortable: true
    },
    {
      id: 'noOfQuestionsCompleted',
      label: <Title>{tUpper('Questions Completed')}</Title>,
      sortKey: 'noOfQuestionsCompleted',
      getValue: item => <Typography>{getDefaultText(item.noOfQuestionsCompleted)}</Typography>,
      sortable: true
    },
    {
      id: 'noOfTries',
      label: <Title>{tUpper('Avg Tries Per Question')}</Title>,
      sortKey: 'noOfTries',
      getValue: item => <Typography>{getDefaultText(item.noOfTries)}</Typography>,
      sortable: true
    },
    {
      id: 'noOfQuestion',
      label: <Title>{tUpper('Questions Answered In One Try')}</Title>,
      sortKey: 'noOfQuestion',
      getValue: item => <Typography>{getDefaultText(item.noOfQuestion)}</Typography>,
      sortable: true
    },
    {
      id: 'module1Progress',
      label: <Title>{tUpper('Module 1 Status')}</Title>,
      sortKey: 'module1Progress',
      getValue: item => (
        <ModuleStatusChip status={item.module1Progress} style={{ maxWidth: 'fit-content' }} />
      ),
      helpText: ModuleStatusHelp
    },
    {
      id: 'module2Progress',
      label: <Title>{tUpper('Module 2 Status')}</Title>,
      sortKey: 'module2Progress',
      getValue: item => (
        <ModuleStatusChip status={item.module2Progress} style={{ maxWidth: 'fit-content' }} />
      ),
      helpText: ModuleStatusHelp
    },
    {
      id: 'module3Progress',
      label: <Title>{tUpper('Module 3 Status')}</Title>,
      sortKey: 'module3Progress',
      getValue: item => (
        <ModuleStatusChip status={item.module3Progress} style={{ maxWidth: 'fit-content' }} />
      ),

      helpText: ModuleStatusHelp
    }
  ];
};

export default getAllStudentModuleColumns;
